<h3 class="ui primary header">
  Chat with NCC
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <!-- <app-message [objectId]="data"></app-message> -->

  <div class="ui secondary segment">
    <!-- current chat messages -->
    <div class="hide-scroll">
      <!-- messages with timer displayed when during api request-->

      <div *ngIf="success || error" appMargin marginY="10px">
        <esl-message-toast [(message)]="error"></esl-message-toast>
        <esl-message-toast
          [(message)]="success"
          [messageType]="'success'"
        ></esl-message-toast>
      </div>

      <div
        class="scroll-wrapper ui basic segment"
        [ngClass]="{ loading: pending }"
      >
        <div
          #scrollContainer
          id="scrollMe"
          infinite-scroll
          [scrollWindow]="true"
          [infiniteScrollUpDistance]="2"
          (scrolled)="onScrollDown($event)"
          (scrolledUp)="onScrollUp($event)"
          appPadding="0"
          class="scroll-wrapper ui basic segment"
        >
          <div *ngFor="let comment of messages">
            <app-chat-view [msg]="comment" (reply)="onReply($event)">
            </app-chat-view>
          </div>
        </div>
      </div>
    </div>

    <!-- Forms to send a chat that is or is not a reply -->

    <!-- reply form -->
    <div
      appPadding="0px"
      appMargin
      marginX="30px"
      marginT="20px"
      class="ui basic segment"
      *ngIf="isReply"
    >
      <div appPadding="0px" class="ui basic segment" id="reply-block">
        <div
          class="ui circular red tiny right floating label clickable"
          (click)="removeReply()"
        >
          <i appMargin="0px" class="cancel icon"></i>
        </div>
        <div appMargin="0px" class="ui segment">
          <app-chat-view isReply="true" [msg]="isReply"> </app-chat-view>
        </div>
      </div>
      <div class="ui form" [formGroup]="replyForm">
        <div
          class="field"
          fxLayout="row"
          fxLayoutGap="3px"
          fxLayoutAlign="space-between end"
        >
          <div class="field" fxFlex="grow">
            <div
              class="content-area"
              contenteditable
              formControlName="comment"
              placeholder="Enter comment..."
            ></div>
          </div>
        </div>
        <!-- attachment shown if added -->
        <div>
          <div
            class="ui image fluid primary label"
            *ngIf="fileObj"
            appMargin
            marginB="10px"
          >
            Attachment:
            <span>{{ fileName }}</span>
            <i
              class="delete icon"
              (click)="removeFile()"
              style="float: right"
              suiPopup
              popupPlacement="top"
              popupText="remove attachment"
            ></i>
          </div>
          <!-- <div appMargin marginY="10px" *ngIf="">
              <sui-message class="info" [isDismissable]="false">
                <p>You may attach only one file at a time!</p>
                <p>please remove previous attachment first to make a new selection</p>
              </sui-message>
            </div> -->
        </div>

        <div
          *isPermitted="{ id: 'CHAT', action: 'add' }"
          class="field"
          fxLayout="row"
          fxLayoutGap="3px"
          fxLayoutAlign="space-between center"
        >
          <div
            class="attachment-section"
            fxFlex="20%"
            fxLayout="row"
            fxLayoutGap="8px"
          >
            <div>
              <button
                class="ui tiny icon button"
                (click)="fileUploader.click()"
                suiPopup
                popupPlacement="top"
                popupText="upload file"
              >
                <img
                  src="assets/icons/attach_file_24px.svg"
                  alt="file-attachment-icon"
                />
              </button>
              <input
                hidden
                type="file"
                accept=".pdf, .xlsx, .docx"
                #fileUploader
                (change)="uploadDoc($event.target.files)"
                placeholder="Browse for documents"
                onclick="value = null"
              />
            </div>

            <div>
              <button
                class="ui tiny icon button"
                (click)="imgUploader.click()"
                suiPopup
                popupPlacement="top"
                popupText="upload image"
              >
                <img
                  src="assets/icons/image_24px.svg"
                  alt="image-attachment-icon"
                />
              </button>
              <input
                hidden
                type="file"
                accept=".jpg, .jpeg, .png"
                #imgUploader
                (change)="uploadDoc($event.target.files)"
                placeholder="Browse for documents"
                onclick="value = null"
              />
            </div>
          </div>
          <div fxFlex class="text-right">
            <button
              class="ui tiny primary button"
              [disabled]="!replyForm.valid"
              (click)="send(isReply.messageId)"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- not a reply form -->
    <div
      *ngIf="!isReply"
      appMargin
      marginT="10"
      class="ui form"
      [formGroup]="replyForm"
    >
      <div
        class="field"
        fxLayout="row"
        fxLayoutGap="3px"
        fxLayoutAlign="space-between end"
      >
        <div class="field" fxFlex="grow">
          <div
            class="content-area"
            contenteditable
            formControlName="comment"
            placeholder="Enter comment..."
          ></div>
        </div>
      </div>

      <!-- attachment shown if added -->
      <div
        *ngIf="fileObj"
        class="ui image fluid primary label"
        appMargin
        marginB="10px"
      >
        Attachment:
        <span>{{ fileName }}</span>
        <i
          class="delete icon"
          (click)="removeFile()"
          style="float: right"
          suiPopup
          popupPlacement="top"
          popupText="remove attachment"
        ></i>
      </div>
      <div
        *isPermitted="{ id: 'CHAT', action: 'add' }"
        class="field"
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="space-between center"
      >
        <div
          class="attachment-section"
          fxFlex="20%"
          fxLayout="row"
          fxLayoutGap="8px"
        >
          <div>
            <button class="ui tiny icon button" (click)="fileUploader.click()">
              <img
                src="assets/icons/attach_file_24px.svg"
                alt="file-attachment-icon"
                suiPopup
                popupPlacement="top"
                popupText="upload file"
              />
            </button>
            <input
              hidden
              type="file"
              accept=".pdf, .xlsx, .docx"
              #fileUploader
              (change)="uploadDoc($event.target.files)"
              placeholder="Browse for documents"
              onclick="value = null"
            />
          </div>

          <div>
            <button class="ui tiny icon button" (click)="imgUploader.click()">
              <img
                src="assets/icons/image_24px.svg"
                alt="image-attachment-icon"
                suiPopup
                popupPlacement="top"
                popupText="upload image"
              />
            </button>
            <input
              hidden
              type="file"
              accept=".jpg, .jpeg, .png"
              #imgUploader
              (change)="uploadDoc($event.target.files)"
              placeholder="Browse for documents"
              onclick="value = null"
            />
          </div>
        </div>

        <div fxFlex class="text-right">
          <button
            class="ui tiny primary button"
            [disabled]="!replyForm.valid"
            (click)="send('null')"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
